import { ProductsService } from './../../services/products.service';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';

import { ProductsDataSource } from '../../datasources/products-data-source';
import { SelectionModel } from '@angular/cdk/collections';
import { Product } from '../../models/product.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-admin-products',
  templateUrl: './admin-products.component.html',
  styleUrls: ['./admin-products.component.scss']
})
export class AdminProductsComponent implements OnInit, AfterViewInit {
  dataSource: ProductsDataSource;
  displayedColumns = [
    'productCode',
    'productDescription',
    'status',
    'updatedBy',
    'isPrintable',
    'updated',
    'actions'
  ];
  selection = new SelectionModel<Product>(true, []);
  viewOnlyActive = true;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private productsService: ProductsService) {}

  ngOnInit() {
    this.dataSource = new ProductsDataSource(this.productsService);
    this.dataSource.loadProducts(null, null, null, true);
  }
  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.loadProducts();
    });
    this.paginator.page.pipe(tap(() => this.loadProducts())).subscribe();
  }

  loadProducts() {
    this.dataSource.loadProducts(
      this.paginator.pageIndex + 1,
      this.paginator.pageSize,
      (this.sort.direction === 'desc' ? '-' : '') + this.sort.active,
      this.viewOnlyActive
    );
  }

  changeOnlyActive() {
    this.viewOnlyActive = !this.viewOnlyActive;
    this.loadProducts();
  }
}
